const ACTIONS = {
    TRIGGER_VT_EXIT_TOAST: 'VT_HELPFULNESS/TRIGGER_VT_EXIT_TOAST',
    UPDATE_VT_HELPFULNESS_HISTORY: 'VT_HELPFULNESS/UPDATE_HISTORY'
};

const ACTION_CREATORS = {
    triggerVTExitToast(viewerVersion, helpfulnessHistory) {
        return {
            type: ACTIONS.TRIGGER_VT_EXIT_TOAST,
            payload: {
                viewerVersion,
                helpfulnessHistory
            }
        };
    },

    updateVTHelpfulnessHistory(vtHelpfulnessHistory) {
        return {
            type: ACTIONS.UPDATE_VT_HELPFULNESS_HISTORY,
            payload: {
                vtHelpfulnessHistory
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
